import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { useBrandMilestone } from "@faire/help-center-utils/hooks/useBrandMilestones";
import { useRetailerMilestone } from "@faire/help-center-utils/hooks/useRetailerMilestones";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getIsUserImpersonating } from "@faire/help-center-utils/serialized-data/getIsUserImpersonating";
import { getRetailerToken, isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getUserToken } from "@faire/help-center-utils/serialized-data/getUser";
import { logError } from "@faire/web--source/common/logging";
import { isProduction } from "@faire/web--source/common/user-agent/isProduction";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { useQuery as useArticleLocationTagsQuery } from "@faire/web-api--source/api/help-center/chat-bot/article-location-tags/get-hooks";
import { useQuery as useChatbotAuthQuery } from "@faire/web-api--source/api/help-center/chat-bot/auth/get-hooks";
import { trackHelpCenterAiChatbotWidgetOpenView } from "@faire/web-api--source/events/helpCenter/view/aiChatbotWidgetOpen";
import { QueryParameters as SupportQueryParameters } from "@faire/web-api--source/routes/support";
import { route as supportSelfServeChatCsat } from "@faire/web-api--source/routes/support/self-serve/chat-csat";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useChatbotStaticMetadata } from "../useChatbotStaticMetadata";
import { DECAGON_SCRIPT_URL, DecagonHandoffTags } from "./consts";
import { useEnvironment } from "./useEnvironment";
var TEN_MINUTES_IN_MS = 10 * 60 * 1000; // 10 minutes
export var useDecagon = function useDecagon() {
  var _useQueryParams = useQueryParams(SupportQueryParameters.parse),
    faire_direct_widget_chat = _useQueryParams.faire_direct_widget_chat;
  var retailerToken = getRetailerToken();
  var brandToken = getBrandToken();
  var isUserImpersonating = getIsUserImpersonating();
  var userToken = getUserToken();
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useAIChatbotAccess = useAIChatbotAccess(),
    hasAIChatbotAccess = _useAIChatbotAccess.hasAIChatbotAccess,
    isAccessControlLoading = _useAIChatbotAccess.isAccessControlLoading;
  var _useChatbotAuthQuery = useChatbotAuthQuery({
      enabled: hasAIChatbotAccess
    }),
    chatbotAuthResponse = _useChatbotAuthQuery.data,
    refetchChatbotAuth = _useChatbotAuthQuery.refetch,
    isChatbotAuthLoading = _useChatbotAuthQuery.isLoading;
  var _useArticleLocationTa = useArticleLocationTagsQuery({
      enabled: hasAIChatbotAccess
    }),
    articleLocationResponse = _useArticleLocationTa.data,
    isArticleLocationTagsLoading = _useArticleLocationTa.isLoading;
  var metadata = useChatbotStaticMetadata();
  var _ref = articleLocationResponse !== null && articleLocationResponse !== void 0 ? articleLocationResponse : {},
    tags = _ref.tags;
  var _ref2 = chatbotAuthResponse !== null && chatbotAuthResponse !== void 0 ? chatbotAuthResponse : {},
    signature = _ref2.signature,
    expires_at = _ref2.expires_at,
    user_token = _ref2.user_token,
    jwt = _ref2.jwt;
  var _useRetailerMilestone = useRetailerMilestone("RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN"),
    setRetailerChatbotTooltipOccurred = _useRetailerMilestone.setHasOccurred;
  var _useBrandMilestone = useBrandMilestone("BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN"),
    setBrandChatbotTooltipOccurred = _useBrandMilestone.setHasOccurred;
  var env = useEnvironment();
  var setRefreshChatbotAuth = function setRefreshChatbotAuth(expires_at) {
    if (!expires_at) {
      return;
    }
    // check if current time is 10 minutes before expires_at
    var currentTime = new Date().getTime();
    var timeDifference = expires_at * 1000 - currentTime;
    if (timeDifference <= TEN_MINUTES_IN_MS) {
      refetchChatbotAuth().then(function (_ref3) {
        var data = _ref3.data;
        var _ref4 = data !== null && data !== void 0 ? data : {},
          signature = _ref4.signature,
          expires_at = _ref4.expires_at,
          user_token = _ref4.user_token,
          jwt = _ref4.jwt;
        window.duet.setUserIdAuth(signature, expires_at);
        window.duet.setUserId(user_token);
        window.duet.setMetadata(_objectSpread(_objectSpread({}, metadata), {}, {
          token: jwt,
          env: env
        }));
      });
    }
  };
  useEffect(function () {
    if (pathname === supportSelfServeChatCsat) {
      return;
    }
    if (isAccessControlLoading || isArticleLocationTagsLoading || isChatbotAuthLoading) {
      return;
    }
    // If the user is not impersonating and we don't have a jwt, we don't want to load the chatbot
    if (!isUserImpersonating && !jwt) {
      return;
    }
    try {
      if (hasAIChatbotAccess) {
        var script = document.createElement("script");
        script.src = DECAGON_SCRIPT_URL;
        script.async = true;
        document.body.appendChild(script);
        script.addEventListener("load", function () {
          var decagonMetadata = _objectSpread(_objectSpread({}, metadata), {}, {
            user_article_location_tags: tags,
            token: jwt,
            env: env
          });
          if (faire_direct_widget_chat === "1") {
            decagonMetadata.handoff_tags = DecagonHandoffTags.BrandFaireDirectWidgetChat;
          }
          window.duet.setMetadata(decagonMetadata);
          window.duet.setUserId(user_token !== null && user_token !== void 0 ? user_token : userToken);
          window.duet.setUserIdAuth(signature, expires_at);
          window.duet.setChatSessionDuration(1); // set the chat session duration to 1 hour
          window.duet.setEventListener(function (event) {
            if (event.eventName === "DUET_INITIALIZE") {
              if (isRetailer()) {
                setRetailerChatbotTooltipOccurred();
              } else {
                setBrandChatbotTooltipOccurred();
              }
              trackHelpCenterAiChatbotWidgetOpenView(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", brandToken !== null && brandToken !== void 0 ? brandToken : "", pathname, "");
              setRefreshChatbotAuth(expires_at);
            }
            if (event.eventName === "DUET_USER_INPUT") {
              setRefreshChatbotAuth(expires_at);
            }
          });
          if (!isProduction()) {
            window.duet.setIsConversationUrlVisible(true);
          }
          if (faire_direct_widget_chat === "1") {
            window.duet.open();
          }
        });
        return function () {
          document.body.removeChild(script);
        };
      }
    } catch (error) {
      logError("Error loading Decagon script, ".concat(error), {
        data: {
          pathname: pathname,
          retailerToken: retailerToken,
          brandToken: brandToken,
          metadata: metadata
        },
        autoFingerprint: true
      });
    }
    return function () {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAIChatbotAccess, isArticleLocationTagsLoading, isChatbotAuthLoading]);
};